export default "__VITE_ASSET__61f6de65__"